import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CurrencyContext = createContext({ currency: "GBP", setCurrency: () => {}, rates: {}, format: () => "" });

export const CURRENCIES = [
  { code: "GBP", symbol: "£", label: "Pound Sterling" },
  { code: "USD", symbol: "$", label: "US Dollar" },
  { code: "EUR", symbol: "€", label: "Euro" },
  { code: "NGN", symbol: "₦", label: "Nigerian Naira" },
  { code: "GHS", symbol: "₵", label: "Ghanaian Cedi" },
  { code: "KES", symbol: "KSh", label: "Kenyan Shilling" },
  { code: "ZAR", symbol: "R", label: "South African Rand" },
];

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("sbc_currency") || "GBP");
  const [rates, setRates] = useState({ base: "GBP", rates: { GBP: 1, USD: 1.27, EUR: 1.17, NGN: 1990, GHS: 15.6, KES: 165, ZAR: 23.8 } });

  useEffect(() => {
    api.get("/fx/rates").then((r) => setRates({ base: r.data.base || "GBP", rates: r.data.rates || {} })).catch(() => {});
  }, []);

  const setCurrency = (c) => { setCurrencyState(c); localStorage.setItem("sbc_currency", c); };

  const format = (amountInBase, opts = {}) => {
    const rate = rates.rates?.[currency] ?? 1;
    const value = amountInBase * rate;
    const cur = CURRENCIES.find((x) => x.code === currency) || CURRENCIES[0];
    const digits = opts.digits ?? (value >= 1000 ? 0 : 2);
    return `${cur.symbol}${value.toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits })}`;
  };

  return <CurrencyContext.Provider value={{ currency, setCurrency, rates, format }}>{children}</CurrencyContext.Provider>;
}

export const useCurrency = () => useContext(CurrencyContext);
